import { Component, effect, inject, input, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { type IncidentStatisticsDto, IncidentsV2Service } from '@api/incidents';
import { NavigationService, queryParamUtils } from '@core';
import { IncidentSeverity } from '@models';

import { IncidentsFilters } from '../../models';
import { buildIncidentsFilters } from '../tables/incidents-v2-table/incidents-v2-table.store';
import { IncidentSeverityIconComponent } from '../incident-status';

@Component({
  imports: [MatCardModule, IncidentSeverityIconComponent],
  selector: 'avs-incidents-stats',
  styleUrl: './incidents-stats.component.scss',
  templateUrl: './incidents-stats.component.html',
})
export class IncidentsStatsComponent {
  display = input({
    createdToday: true,
    resolvedRatio: false,
  });
  filters = input<IncidentsFilters>();
  type = input<'opened' | 'resolved'>('opened');

  protected eIncidentSeverity = IncidentSeverity;
  protected stats = signal<IncidentStatisticsDto | null>(null);

  private incidentsV2Service = inject(IncidentsV2Service);
  private navigationService = inject(NavigationService);

  constructor() {
    /*
     * `onCleanup` cancels the in-flight request whenever `filters()` changes
     * again before the current one resolves (and on destroy) — without it, a
     * slower older request resolving after a newer one would silently
     * overwrite fresher stats with stale data. Same fix as `IncidentsV2StatsComponent`.
     */
    effect(onCleanup => {
      const filters = buildIncidentsFilters({ ...this.filters() });

      const subscription = this.incidentsV2Service.getStatistics({ clientId: this.navigationService.getCurrentClientId() }, {
        filters: filters.length > 0 ? queryParamUtils.toJsonQueryParam(filters) : undefined,
      }).subscribe(({ data }) => this.stats.set(data));

      onCleanup(() => subscription.unsubscribe());
    });
  }
}
